import { Signal, signal } from '@angular/core';
import { ResolveFn } from '@angular/router';

export const categoriesDummyResolver: ResolveFn<Signal<string[]>> = () => {
  return signal<string[]>(['']);
};
